import { Heading } from '@/components/primitives/Heading/Heading'

import RichTextEditor from '../RichTextEditor/RichTextEditor'

import type { Document } from '@contentful/rich-text-types'

export function HalfHalfBlockCopy({ title, titleSize = 'large', subtextRichText }: { title?: string; titleSize?: 'large' | 'small'; subtextRichText?: Document }) {
  return (
    <>
      {title && (
        <Heading as="h2" size={titleSize === 'small' ? 'h2' : 'h1'} className="mb-4 md:mb-5">
          {title}
        </Heading>
      )}
      {!!subtextRichText && (
        <div className="mb-6 md:mb-8">
          <RichTextEditor content={subtextRichText} />
        </div>
      )}
    </>
  )
}
